import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import classNames from 'classnames/bind';
import { Button, Text } from '@carnica/ui-kit';
import { Metric } from "../../../../../../metric";
import { MenuUrlTarget } from "../../../../../../types";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var TabsItem = function TabsItem(_ref) {
  var isActive = _ref.isActive,
    tab = _ref.tab,
    activeCategory = _ref.activeCategory,
    _onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("li", {
    className: cn('tabs-item'),
    key: tab.title
  }, /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: JSON.stringify({
      tab: tab.title,
      section: activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.title
    }),
    events: {
      headerMetric: ['handleNavTabClick']
    },
    mode: "click"
  }, /*#__PURE__*/React.createElement(Button, _extends({
    className: cn('tab', {
      'tab--active': isActive
    }),
    mode: "inline"
  }, tab.url ? {
    href: tab.url,
    tagName: 'a',
    target: MenuUrlTarget.get(tab.isBlankUrlTarget)
  } : {
    onClick: function onClick() {
      return _onClick(tab);
    }
  }), /*#__PURE__*/React.createElement(Text, {
    className: cn('tab__text'),
    color: "primary-invert",
    lineHeight: 20,
    size: 16
  }, tab.title))));
};